module.exports = __webpack_public_path__ + "static/media/baby_octo_alpha_map.c0983ad5.png";